const trimTrailingSlash = (value) => value.replace(/\/+$/, '');

const API_BASE_URL = trimTrailingSlash(import.meta.env.VITE_API_BASE_URL || '/api');
const MQTT_HUB_URL = import.meta.env.VITE_MQTT_HUB_URL
  || `${API_BASE_URL}/mqtthub`;
const MQTT_WS_URL = import.meta.env.VITE_MQTT_WS_URL || '';
const MQTT_DEFAULT_TOPIC = import.meta.env.VITE_MQTT_TOPIC || 'test';

function apiUrl(path) {
  if (!path) {
    return API_BASE_URL;
  }

  return `${API_BASE_URL}${path.startsWith('/') ? path : `/${path}`}`;
}

export {
  API_BASE_URL,
  MQTT_HUB_URL,
  MQTT_WS_URL,
  MQTT_DEFAULT_TOPIC,
  apiUrl,
};
